import { observer } from 'mobx-react-lite';
import { useLessonStore } from './provider/LessonProvider';
import { twMerge } from 'tailwind-merge';
import { CSSProperties } from 'react';
import themeStore from '../../stores/themeStore';

const ChapterList = observer(() => {
    const lessonStore = useLessonStore();

    const handleChapterClick = (chapterNum: number) => {
        // 문장은 1로 초기화
        lessonStore.setChapter(chapterNum, 1);
    };

    return (
        <div className="space-y-2">
            {(lessonStore.isLoading ||
                lessonStore.hasLessonError ||
                lessonStore.isCreatingLesson) &&
                Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} className="skeleton h-11 rounded"></div>
                ))}
            {lessonStore.chapterList.map((chapter) => {
                const isActive = chapter.num === lessonStore.currentChapterNum;
                return (
                    <div
                        key={chapter.hash}
                        className={twMerge(
                            'flex h-11 cursor-pointer flex-row items-center gap-2 rounded pr-5 pl-4 transition-colors',
                            isActive && 'bg-primary/10 text-primary',
                            !isActive && 'text-base-content/70 bg-base-200 hover:bg-base-300',
                        )}
                        onClick={() => {
                            handleChapterClick(chapter.num);
                        }}
                    >
                        <div className="relative flex size-6 shrink-0 flex-row items-center justify-center gap-2">
                            <div
                                className={twMerge(
                                    'text-base-content/70 text-xs',
                                    isActive && 'text-primary',
                                )}
                            >
                                {chapter.num}
                            </div>
                            <div
                                // 원형 프로그레스바의 크기도 동일하게 하단에 보더
                                // radial-progress 에 보더를 그리면 보더가 바깥쪽에 위치하게 돼서 별도로 그램
                                className="border-base-content/5 absolute top-0 right-0 bottom-0 left-0 z-10 size-6 shrink-0 rounded-full border-2"
                            ></div>
                            <div
                                // 원형 프로그레스바
                                className="radial-progress absolute inset-0 z-20 size-6 shrink-0"
                                style={
                                    {
                                        // color-mix로 primary/40을 배경색과 혼합하여 불투명한 색상으로 변환
                                        // (opacity 색상은 radial-progress에서 점이 겹쳐 진하게 보이는 문제가 있음)
                                        // color-mix(in oklch, 색상1 비율%, 색상2)
                                        color:
                                            themeStore.themeToRender === 'dark'
                                                ? 'color-mix(in oklab, var(--color-primary) 100%, black 30%)' // 다크 테마
                                                : 'color-mix(in oklab, var(--color-primary) 70%, white 100%)', // 라이트 테마
                                        '--value': Math.floor(Math.random() * 100), // TODO 실제 진도율로 변환
                                        '--size': '24px',
                                        '--thickness': '2px',
                                    } as CSSProperties
                                }
                            ></div>
                        </div>
                        <div className="flex-1 truncate text-sm">{chapter.title}</div>
                    </div>
                );
            })}
        </div>
    );
});

export default ChapterList;
